export enum Role {
  OaClient = 'Klient OA',
  Admin = 'Admin',
  Superadmin = 'Superadmin',
  OaCoordinator = 'Koordinátor OA',
  OaAssistant = 'Asistent OA',
  SrWorker = 'Pracovník SR',
  SrClient = 'Klient SR',
  Financial = 'Finanční',
  SrManager = 'Vedoucí SR',
  Personal = 'Personální',
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace RoleGroup {
  export const workers: Role[] = [Role.Superadmin, Role.Admin, Role.OaCoordinator, Role.SrWorker, Role.Financial]
  export const all: Role[] = Object.values(Role)
}
